import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';
import classNames from 'classnames';

interface IProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	translationKey: string;
	dataTest: string;
	descriptionKey?: string;
}

export const PushOptionCheckbox: React.FC<IProps> = ({
	checked,
	onChange,
	translationKey,
	dataTest,
	descriptionKey,
}) => {
	const handleChange = (e: CheckboxChangeEvent) => {
		onChange(e.target.checked);
	};

	return (
		<div className={classNames('mt-4 flex', { 'flex-col gap-1': descriptionKey })}>
			<Checkbox checked={checked} onChange={handleChange} data-test={dataTest}>
				<Text
					translationNameSpace="modals"
					translationKey={translationKey}
					size="m"
					weight="bold"
					display="inline"
				/>
			</Checkbox>
			{descriptionKey && (
				<Text className="ml-6" translationNameSpace="modals" translationKey={descriptionKey} size="s" />
			)}
		</div>
	);
};
